import React from "react";
import DefaultButton from "../../default-button/DefaultButton";
import Cross from "../../../assets/icons/Cross";
import pdf from "../../../assets/png/pdf.png";
import EyeGrayBg from "../../../assets/svg/eye-bg.svg";
import DownloadGrayBg from "../../../assets/svg/download-bg.svg";
import msg from "../../../assets/svg/message-gray.svg";
import { Media, SocialTranscriptItem } from "../../../types";
import { Avatar } from "../../Avatar";
import {
  getDateOnly,
  updateMiscState,
} from "../../../misc/utils";
import { HasRole } from "../../HasRole";

type Props = {
  doc: SocialTranscriptItem;
};

export default function DocumentCard({ doc }: Props) {
  const media: Media = doc.media[0] || {};

  const onDelete = (display: boolean) => async () => {
    updateMiscState("isSocialTranscriptItemModalVisible")(true);
    updateMiscState("socialTranscriptRejectDoc")(doc);
    updateMiscState("socialTranscriptRejectMode")(
      display ? "display" : "update"
    );
  };

  const onDownloadFile = () => {
    const link = document.createElement("a");
    link.href = media.link;
    link.setAttribute("download", media.filename || "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <tr className='border-t border-[#F0F3FA] align-middle'>
      <td className='px-2 py-3 align-middle'>
        <div className='flex items-center gap-3 font-medium min-w-0'>
          <Avatar user={doc.main_user} />
          <p className='truncate'>
            {doc.main_user.json_saved_data.firstname}{" "}
            {doc.main_user.json_saved_data.lastname}
          </p>
        </div>
      </td>

      <td className='px-2 py-3 align-middle'>
        <p className='text-[#5F6B88] font-medium truncate'>
          {doc.social_subcategory.social_category?.name}
        </p>
      </td>

      <td className='px-2 py-3 align-middle'>
        <p className='text-[#5F6B88] font-medium truncate'>
          {doc.social_subcategory.name}
        </p>
      </td>

      <td className='px-2 py-3 align-middle whitespace-nowrap'>
        <p className='text-[#5F6B88] font-medium'>{getDateOnly(doc.createdAt)}</p>
      </td>

      <td className='px-2 py-3 align-middle whitespace-nowrap'>
        <p className='text-[#5F6B88] font-medium'>
          {doc?.event_date
            ? new Date(doc?.event_date).toLocaleDateString()
            : "-"}
        </p>
      </td>

      <td className='px-2 py-3 align-middle'>
        <p className='text-[#5F6B88] font-medium truncate'>{doc?.description || "-"}</p>
      </td>

      <td className='px-2 py-3 align-middle'>
        <p className='text-[#5F6B88] font-medium truncate'>
          {doc?.link ? (
            <a
              href={doc?.link}
              target='_blank'
              rel='noreferrer'
              className='text-blue-600 underline hover:text-blue-800 hover:no-underline'
            >
              ссылка
            </a>
          ) : (
            "-"
          )}
        </p>
      </td>

      <td className='px-2 py-3 align-middle'>
        <div className='flex items-center border rounded-lg border-[#F0F3FA] px-2 py-[6px] gap-3 min-w-0'>
          <img src={pdf} alt='pdf' className='flex-shrink-0' />
          <p className='text-black truncate flex-1 min-w-0'>
            {media.filename || media.link}
          </p>
          <a
            href={media.link}
            target='_blank'
            rel='noreferrer'
            className='p-0 bg-transparent flex-shrink-0'
          >
            <img src={EyeGrayBg} alt='preview' />
          </a>
          <button
            onClick={onDownloadFile}
            className='p-0 bg-transparent flex-shrink-0'
          >
            <img src={DownloadGrayBg} alt='download' />
          </button>
        </div>
      </td>

      <td className='px-2 py-3 align-middle'>
        <div className='flex justify-start lg:justify-center'>
          {doc.status === 0 ? (
            <HasRole roles={["decide_on_social_transcript_items"]}>
              <DefaultButton
                buttonText='Отказать'
                additionalStyle='text-[#F12D2D] border-1 border-[#F12D2D] py-[6px] px-3 font-medium gap-2 whitespace-nowrap'
                Icon={Cross}
                onClick={onDelete(false)}
              />
            </HasRole>
          ) : (
            <div className='flex text-[#F12D2D] gap-2 items-center'>
              <Cross />
              <p className='whitespace-nowrap'>Отказано</p>
              <button onClick={onDelete(true)} className='p-0 bg-transparent'>
                <img src={msg} alt='' />
              </button>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}
